import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import * as routes from '../../../Routing/routes';

const VendorSetting = () => {
    const navigate = useNavigate();

    useEffect(() => {
        navigate(routes.SOCIETY_PORTAL + routes.SOCIETY_PORTAL_VENDOR_SETTINGS_BILLING, { replace: true });
    }, [navigate]);

    return null;
};

export default VendorSetting;
